module.exports = __webpack_public_path__ + "static/ap-6a476ae61d00434e9e2c6da44251c6d5.webp";